import * as Sentry from "@sentry/browser";
import type * as Core from "@zeller-public/payments-sdk-core";

import { onRequestQueryEnd } from "../on-request-query-end";
import { logger } from "../shared/logger";
import { $postMessage } from "./post-message";

////////////////////////////////////////////////////////////////////////////////

export function postResponse(
	response: Exclude<Core.Protocol.Response, string>,
): void {
	logger.debug("post response: send", {
		$type: response.$type,
		value:
			response.$type === "Result" || response.$type === "ResultError"
				? response.value
				: response,
	});

	// Host resolves its one pending call on either.
	const endsOperation =
		response.$type === "Result" || response.$type === "ResultError";

	if (endsOperation) {
		// Before onRequestQueryEnd, which clears the scope and window._request.
		// Unparsed-message rejections count too: they end the host's call.
		// No payload: a Result holds card data, so it stays on debug, which
		// `beforeSendLog` drops.
		logger.info("request: completed", {
			"zeller.response.outcome": response.$type,
			...(response.$type === "ResultError" && {
				"zeller.response.errorType": response.value.type,
			}),
		});

		onRequestQueryEnd();

		// Flush before posting: the buffer waits 5s, and a native host can
		// destroy the WebView inside $postMessage.
		void Sentry.flush(0);
	}

	$postMessage(JSON.stringify(response));
}
